import httpClient from '@core/http/httpClient';
import { apiPaths } from '@core/http/apiPaths';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPathPayload } from '@hwm/ui-lib';
import { AxiosResponse } from 'axios';
import { AccountModel } from '@models/Account';

const fetchSubaccounts = createAsyncThunk(
  `accounts/fetchSubaccounts`,
  async (params: getPathPayload<typeof apiPaths.accounts.subaccounts>) => {
    const response: AxiosResponse<AccountModel[]> = await httpClient.get(
      apiPaths.accounts.subaccounts({
        ...params,
      })
    );

    return response.data;
  }
);

const fetchById = createAsyncThunk(
  `accounts/fetchById`,
  async (params: getPathPayload<typeof apiPaths.accounts.getById>) => {
    const response: AxiosResponse<AccountModel> = await httpClient.get(apiPaths.accounts.getById(params));

    return response.data;
  }
);

export const accountsThunks = { fetchSubaccounts, fetchById };
